<template>
  <div class="league-match-container">
    <div class="action-header">
      <el-button type="primary" @click="handleAdd">添加联盟赛事</el-button>
    </div>
    <el-table
      v-loading="listLoading"
      :data="list"
      style="width: 100%">
      <el-table-column
        prop="leagueName">
        <template slot="header" slot-scope="scope">
          <div>联盟简称</div>
          <el-input
            v-model="search.leagueName"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="matchName">
        <template slot="header" slot-scope="scope">
          <div>赛事名称</div>
          <el-input
            v-model="search.matchName"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        prop="season">
        <template slot="header" slot-scope="scope">
          <div>赛季</div>
          <el-input
            v-model="search.season"
            placeholder="搜索"
            @change="quickSearch"
          />
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="150"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="prev, pager, next"
        @current-change="handleCurrentChange"/>
    </div>

    <!-- create/edit modal start -->
    <el-dialog :visible.sync="dialogVisible" :close-on-click-modal="false" :title="modalTitle" center>
      <el-form ref="dialogForm" :model="dialogForm" :rules="rules" class="modal" label-width="100px">
        <el-form-item label="联盟简称" prop="leagueId">
          <el-select filterable v-model="dialogForm.leagueId" placeholder="请选择">
            <el-option
              v-for="item in leagueList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="赛事名称" prop="matchId">
          <el-select filterable v-model="dialogForm.matchId" placeholder="请选择">
            <el-option
              v-for="item in matchList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属赛季" prop="season">
            <el-input v-model="dialogForm.season" />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('dialogForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!-- create/edit modal start -->
  </div>
</template>

<script>
import { getLeagueMatchList, getLeagueMatchListPagination, addLeagueMatch, getLeagueMatch, deleteLeagueMatch, updateLeagueMatch, getLeagueList, getMatchList } from '@/api/stats'
import { showMessage } from '@/utils'

const defaultForm = {
  leagueId: '',
  matchId: '',
  season: ''
}

export default {
  name: 'leagueMatchList',
  data() {
    return {
      search: {},
      list: [],
      seasonList: [],
      leagueList: [],
      matchList: [],
      dialogForm: {},
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      listQuery: {},
      listLoading: true,
      isEditMode: false,
      modalTitle: '',
      dialogVisible: false,
      formLabelWidth: '100px',
      rules: {
        leagueId: [
          { required: true, message: '请选择联盟', trigger: 'blur' }
        ],
        matchId: [
          { required: true, message: '请选择赛事', trigger: 'blur' }
        ],
        season: [
          { required: true, message: '请输入赛季年份', trigger: 'blur' },
          { pattern: /^\d{4}$/, message: '请输入4位年份数字', trigger: 'blur' }
        ]
      }
    }
  },
  created() {
    this.getList()
    this.getLeagueList()
    this.getMatchList()
  },
  computed: {},
  watch: {},
  methods: {
    handleAdd() {
      this.dialogVisible = true
      this.isEditMode = false
      this.modalTitle = '添加联盟赛事'
      this.dialogForm = Object.assign({}, defaultForm)
    },
    handleEdit(index, row) {
      this.getLeagueMatchById(this.list[index].id)
      this.dialogVisible = true
      this.isEditMode = true
      this.modalTitle = '编辑联盟赛事'
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该联盟赛事, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteLeagueMatch(this.list[index].id)
      }).catch(() => {
      })
    },
    // dialog form methods
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.isEditMode) {
            this.updateLeagueMatch()
          } else {
            this.addLeagueMatch()
          }
        } else {
          return false
        }
      });
    },

    resetForm(formName) {
      this.$refs[formName].resetFields();
    },

    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    getLeagueList() {
        getLeagueList({pageSize: 1000}).then(response => {
            const data = response
            this.leagueList = data
        })
    },
    getMatchList() {
        getMatchList({pageSize: 1000}).then(response => {
            const data = response
            this.matchList = data
        })
    },
    getList() {
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getLeagueMatchList(this.listQuery).then(response => {
        const data = response
        this.list = data
        this.listLoading = false
      })
      getLeagueMatchListPagination(this.listQuery).then(response => {
        const data = response[0]
        this.currentPage = data.pageNum
        this.totalCount = data.count
      })
    },
    getLeagueMatchById(id) {
      getLeagueMatch(id).then(response => {
        const data = response[0]
        this.dialogForm = data
      })
    },
    addLeagueMatch() {
      addLeagueMatch(this.dialogForm).then(response => {
        const data = response
        if(data) {
          this.dialogVisible = false
          showMessage('success', '创建成功')
          this.getList()
        }
      })
    },
    updateLeagueMatch() {
      updateLeagueMatch(this.dialogForm).then(response => {
        const data = response
        if(data) {
          this.dialogVisible = false
          showMessage('success', '更新成功')
          this.getList()
        }
      })
    },
    deleteLeagueMatch(id) {
      deleteLeagueMatch(id).then(response => {
        const data = response
        if(data) {
          showMessage('success', '删除成功')
          this.getList()
        }
      })
    },
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
.league-match-container {
  margin: 30px 15px;
  .action-header {
    padding: 0 10px 10px 10px;
  }
  .el-table {
    th {
      div {
        line-height: 20px;
      }
      .el-select {
        padding-left: 0;
        padding-right: 0;
        .el-input {
          padding-left: 0;
          padding-right: 0;
        }
      }
    }
  }

  .table-footer {
    text-align: center;
    margin-top: 30px;
  }

  /* dialog modal start */
  .el-dialog {
    width: 540px;
    .el-form-item {
      .el-input {
        width: 300px;
      }
    }
  }
  /* dialog modal end*/
}
</style>
